export const Logo = ({ size = 34, showText = true, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <img
      src="/vectra-mark.png"
      alt="Vectra logo"
      data-testid="vectra-logo"
      style={{ height: size, width: "auto" }}
      className="object-contain drop-shadow-[0_0_10px_rgba(6,182,212,0.4)]"
    />
    {showText && (
      <div className="leading-none">
        <div className="font-display font-extrabold tracking-tight text-[15px]">VECTRA</div>
        <div className="text-[11px] font-mono text-cyan-400/80 mt-1">Create Cinematic Magic</div>
      </div>
    )}
  </div>
);

export default Logo;
